import {
  cn,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@playerbase/ui';
import type { SemanticTier } from '@playerbase/types';
import { SEMANTIC_TIER_LABELS } from '@playerbase/types';

const TIERS: readonly SemanticTier[] = ['early', 'mid', 'live'] as const;

const TIER_HELP: Readonly<Record<SemanticTier, string>> = {
  early: 'Pre-release / experimental',
  mid: 'Closed beta / RC',
  live: 'Public / shipped',
};

type TierPickerPopoverProps = {
  value: SemanticTier;
  onChange: (next: SemanticTier) => void;
  disabled?: boolean;
};

export function TierPickerPopover({
  value,
  onChange,
  disabled,
}: TierPickerPopoverProps): JSX.Element {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className={cn(
            'rounded-sm border border-border-strong/60 px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider',
            'bg-surface-2/40 text-text-muted transition-colors',
            disabled ? 'opacity-50' : 'hover:bg-surface-2 hover:text-text',
          )}
          aria-label={`Semantic tier: ${SEMANTIC_TIER_LABELS[value]}`}
        >
          {SEMANTIC_TIER_LABELS[value]}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[18rem] p-1" align="end">
        <div className="px-2 py-1 text-[10px] font-mono uppercase tracking-wider text-text-muted">
          Lifecycle position
        </div>
        {TIERS.map((tier) => (
          <button
            key={tier}
            type="button"
            onClick={() => onChange(tier)}
            className={cn(
              'flex w-full items-center gap-2 rounded-sm px-2 py-2 text-left text-sm hover:bg-surface-2',
              tier === value ? 'text-text' : 'text-text-muted',
            )}
          >
            <span className="w-12 font-mono text-xs uppercase tracking-wider">
              {SEMANTIC_TIER_LABELS[tier]}
            </span>
            <span className="text-xs text-text-muted">{TIER_HELP[tier]}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
